import { createAsyncAction } from "typesafe-actions";

import { UserDataInterface } from "../../../shared/interfaces/userData.interface";

export const fetchUserDataAsync = createAsyncAction(
  "FETCH_USER_DATA_REQUEST",
  "FETCH_USER_DATA_SUCCESS",
  "FETCH_USER_DATA_FAILTURE"
)<void, UserDataInterface, string>();
